import type { TR } from '@/i18n/i18n-global'
import type { CategoryInfo, CategoryType } from '@/types'

export function getCategoryPageTitles({
    categoryInfo,
    pageType,
    tr,
}: {
    categoryInfo?: Pick<CategoryInfo, 'fullTitle' | 'title'>
    pageType: CategoryType
    tr: TR
}) {
    const templateTitle = pageType === 'developer' ? categoryInfo?.title || '' : categoryInfo?.fullTitle || ''
    const headingTitle =
        pageType === 'developer' ? tr('categoryPage.developers_full_title', { title: templateTitle }) : templateTitle

    switch (pageType) {
        case 'tag':
            return {
                templateTitle,
                headingTitle,
                defaultMetaTitle: tr('categoryPage.tags_title', { title: templateTitle }),
                defaultMetaDescription: tr('categoryPage.tags_description', { title: templateTitle }),
            }
        case 'series':
            return {
                templateTitle,
                headingTitle,
                defaultMetaTitle: tr('categoryPage.series_title', { title: templateTitle }),
                defaultMetaDescription: tr('categoryPage.series_description', { title: templateTitle }),
            }
        case 'developer':
            return {
                templateTitle,
                headingTitle,
                defaultMetaTitle: tr('categoryPage.developers_title', { title: templateTitle }),
                defaultMetaDescription: tr('categoryPage.developers_description', { title: templateTitle }),
            }
        default:
            return {
                templateTitle,
                headingTitle,
                defaultMetaTitle: tr('categoryPage.title', { title: templateTitle }),
                defaultMetaDescription: tr('categoryPage.description', { title: templateTitle }),
            }
    }
}
